export const SEARCH_FIELDS = [
  'name',
  'canonical_name',
  'phone_number',
  'phone_number_country_code',
]
